import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import styled, { Interpolation } from 'styled-components';

interface ModalActionsProps {
    children?: ReactNode;
    className?: string;
    styles?: Interpolation<CSSProperties>;
}

const StyledModalActions = styled.div<{ styles?: Interpolation<CSSProperties> }>`
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    ${({ styles }) => styles};
`;

const ModalActions: FC<ModalActionsProps> = ({ children, styles, className }) => {
    return (
        <StyledModalActions className={classNames('modal-actions', className)} styles={styles}>
            {children}
        </StyledModalActions>
    );
};

export default ModalActions;
